import EntityDetails from './EntityDetails'

export { EntityDetails }
